module.exports = __webpack_public_path__ + "img/mid-blur.02038ea2.svg";